import React from 'react';

export const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white py-8 mt-16">
      <div className="container mx-auto px-4">
        <div className="text-center">
          <p className="text-gray-300 mb-2">
            LaLala Model Maker - AI-powered custom figure creation
          </p>
          <p className="text-gray-400 text-sm">
            Powered by Gemini AI and OpenAI
          </p>
        </div>
      </div>
    </footer>
  );
};
